import { useCallback, useEffect, useRef } from 'react';

/**
 * Stable handler identity that still sees the latest render's values. Handlers passed to
 * `react-markdown` components must be stable, otherwise every message node remounts and the scroll
 * position jumps. Don't call the result during render.
 */
export function useEventCallback<Args extends unknown[], Result>(
  callback: (...args: Args) => Result,
): (...args: Args) => Result {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  return useCallback((...args: Args) => callbackRef.current(...args), []);
}
